<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!--  <vuexy-logo /> -->
          <b-img
            :src="require('@/assets/images/logo/PRYM-blue-small.png')"
            height="50%"
            alt="PRYM Logo"
          />
        </b-link>

        <b-card-title class="mb-1 text-center">
          We have sent you an email to {{ this.$route.params.email }} to verify
          your account. <p> Please check your inbox and click on the link to verify your account.</p>

        </b-card-title>
      </b-card>
      <!-- /Register v1 -->
    </div>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BLink, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BLink,
    BImg,
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.auth-wrapper.auth-v1 {
    background: url("https://uploads-ssl.webflow.com/61489b3e5856f80b844d9a07/61489b3e5856f824ec4d9b48_background-pricing-tech-ui-kit-webflow-template.svg");
}
.btn-secondary {
    border-color: #171663 !important;
    background-color: #171663!important;
}
a {
    color: #7844fc
}
</style>
